import * as React from "react";

function FooterSection({ title, links }) {
  return (
    <section className="flex flex-col gap-4">
      <h3 className="mb-2 text-base font-semibold leading-6 text-white">
        {title}
      </h3>
      <nav className="flex flex-col gap-3">
        {links.map((link, index) => (
          <button
            type="button"
            key={index}
            className="text-left text-sm leading-5 text-white opacity-90 hover:opacity-100 transition-opacity"
          >
            {link}
          </button>
        ))}
      </nav>
    </section>
  );
}

export default FooterSection;
